export const SPLITTER_TRANSPARENTBAR_WIDTH = 12
export const MIN_LEFT_WIDTH = 80
export const MIN_RIGHT_WIDTH = 80
export const NODE_HEIGHT = 32
export const HEADER_DEFAULT_HEIGHT = 32
